import { MONTHS, WeekDays } from '../constants/date-constants';
import { toNumber } from '../helpers/id-helpers';
import { PlayoffsImplications, TeamBasicContext } from '../types/game-enrichment.types';
import { IGame, IMatchup } from '../types/game.types';
import { ITeamDetails } from '../types/team.types';

export const getTeamsInfo = (homeTeam: ITeamDetails, awayTeam: ITeamDetails): [TeamBasicContext, TeamBasicContext] => {
  const homeTeamContext: TeamBasicContext = {
    id: homeTeam.teamID,
    isHomeTeam: true,
    isIndoor: homeTeam.teamStadiumHasRoof,
    logo: homeTeam.teamLogo,
    name: homeTeam.teamAbrv,
    surface: homeTeam.teamStadiumFieldType,
    rivalries: homeTeam.rivalries,
  };

  const awayTeamContext: TeamBasicContext = {
    id: awayTeam.teamID,
    isHomeTeam: false,
    isIndoor: awayTeam.teamStadiumHasRoof,
    logo: awayTeam.teamLogo,
    name: awayTeam.teamAbrv,
    surface: awayTeam.teamStadiumFieldType,
    rivalries: awayTeam.rivalries,
  };

  return [homeTeamContext, awayTeamContext];
};

export const isPrimeTimeGame = (gameEpochTime: number): boolean => {
  const gameDate = new Date(gameEpochTime * 1000);
  const gameHour = gameDate.getUTCHours();
  // Thursdays, Sunday Nights, and Monday Nights
  return gameDate.getDay() === 4 || (gameDate.getDay() === 0 && gameHour >= 20) || gameDate.getDay() === 1;
};

export const getGameTime = (gameEpochTime: number): string => {
  const gameDate = new Date(gameEpochTime * 1000);
  return (
    WeekDays[gameDate.getDay()] +
    ', ' +
    MONTHS[gameDate.getMonth()] +
    '-' +
    gameDate.getDate() +
    ' @ ' +
    gameDate.getHours().toString().padStart(2, '0') +
    ':' +
    gameDate.getMinutes().toString().padStart(2, '0')
  );
};

export const isDivisionalGame = (homeTeam: ITeamDetails, awayTeam: ITeamDetails): boolean => {
  return homeTeam.teamDivision === awayTeam.teamDivision;
};

export const getPlayoffsImplications = (
  gameData: IGame | IMatchup,
  isDivisionalGame: boolean
): PlayoffsImplications => {
  if (toNumber(gameData.gameWeek) < 8) {
    return isDivisionalGame ? PlayoffsImplications.Medium : PlayoffsImplications.Low;
  } else if (toNumber(gameData.gameWeek) < 15) {
    return isDivisionalGame ? PlayoffsImplications.High : PlayoffsImplications.Medium;
  }

  return PlayoffsImplications.High;
};
